import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgIcon } from '@ng-icons/core';
import { ZardButtonComponent } from '@solvace/zard/shared/components/button';
import { SvzMediaCarouselComponent } from './svz-media-carousel.component';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgIcon, ZardButtonComponent, SvzMediaCarouselComponent],
    exports: [SvzMediaCarouselComponent],
})
export class SvzMediaCarouselModule {}
